import {
  REGISTER_FAILURE,
  REGISTER_SUCCESS,
  REGISTER_REQUEST,
} from "../../actions";

const initialState = {
  isRegistering: false,
};

export const registerReducer = (state = initialState, action) => {
  switch (action.type) {
    case REGISTER_REQUEST: {
      return {
        ...initialState,
        isRegistering: true,
      };
    }

    case REGISTER_SUCCESS: {
      return {
        ...state,
        isRegistering: false,
      };
    }

    case REGISTER_FAILURE: {
      return {
        ...state,
      }
    }

    default: {
      return state;
    }
  }
};
